import { t, useI18n } from "@bookingcom/lingojs-react";
import useUserAgent from "../../../../../../../hooks/useUserAgent.js";
import usePointOfSale from "../../../../../../../hooks/usePointOfSale.js";
import { supplierTerms } from "@flights/content-universal";
export default function useTicketTypeInfoController(flight) {
    const i18n = useI18n();
    const { isMobile } = useUserAgent();
    const countryForSuplierTerms = usePointOfSale();
    const supplierTermsLink = countryForSuplierTerms && supplierTerms.getSupplierTermsUrl(countryForSuplierTerms);
    return {
        header: i18n.trans(t("flights_progress_ticket_type")),
        contentDirection: isMobile ? "column" : "row",
        contentAlignment: isMobile ? undefined : "center",
        contentGap: isMobile ? 0 : 1,
        title: i18n.trans(t("flights_ancillary_flexticket_name")),
        subtitle: i18n.trans(t("flights_meta_flexible_description")),
        status: i18n.trans(t("flights_ancillary_included")),
        supplierTermsLink,
        isPreSelected: flight.ancillaries?.flexibleTicket?.preSelected
    };
}
